import { render } from "./InstructorCard.vue?vue&type=template&id=1fde265e"
import script from "./InstructorCard.vue?vue&type=script&lang=js"
export * from "./InstructorCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__